var map = {
	"./404.svg": "./src/icons/svg/404.svg",
	"./bug.svg": "./src/icons/svg/bug.svg",
	"./chart.svg": "./src/icons/svg/chart.svg",
	"./clipboard.svg": "./src/icons/svg/clipboard.svg",
	"./code.svg": "./src/icons/svg/code.svg",
	"./component.svg": "./src/icons/svg/component.svg",
	"./dashboard.svg": "./src/icons/svg/dashboard.svg",
	"./documentation.svg": "./src/icons/svg/documentation.svg",
	"./drag.svg": "./src/icons/svg/drag.svg",
	"./edit.svg": "./src/icons/svg/edit.svg",
	"./email.svg": "./src/icons/svg/email.svg",
	"./example.svg": "./src/icons/svg/example.svg",
	"./excel.svg": "./src/icons/svg/excel.svg",
	"./eye-open.svg": "./src/icons/svg/eye-open.svg",
	"./eye.svg": "./src/icons/svg/eye.svg",
	"./form.svg": "./src/icons/svg/form.svg",
	"./guide 2.svg": "./src/icons/svg/guide 2.svg",
	"./guide.svg": "./src/icons/svg/guide.svg",
	"./icon.svg": "./src/icons/svg/icon.svg",
	"./international.svg": "./src/icons/svg/international.svg",
	"./language.svg": "./src/icons/svg/language.svg",
	"./line-horizontal.svg": "./src/icons/svg/line-horizontal.svg",
	"./line-vertical.svg": "./src/icons/svg/line-vertical.svg",
	"./link.svg": "./src/icons/svg/link.svg",
	"./list.svg": "./src/icons/svg/list.svg",
	"./lock.svg": "./src/icons/svg/lock.svg",
	"./logout.svg": "./src/icons/svg/logout.svg",
	"./message.svg": "./src/icons/svg/message.svg",
	"./money.svg": "./src/icons/svg/money.svg",
	"./nested.svg": "./src/icons/svg/nested.svg",
	"./open_eye.svg": "./src/icons/svg/open_eye.svg",
	"./password.svg": "./src/icons/svg/password.svg",
	"./people.svg": "./src/icons/svg/people.svg",
	"./peoples.svg": "./src/icons/svg/peoples.svg",
	"./phone.svg": "./src/icons/svg/phone.svg",
	"./print.svg": "./src/icons/svg/print.svg",
	"./qq.svg": "./src/icons/svg/qq.svg",
	"./setting.svg": "./src/icons/svg/setting.svg",
	"./shopping.svg": "./src/icons/svg/shopping.svg",
	"./size.svg": "./src/icons/svg/size.svg",
	"./star.svg": "./src/icons/svg/star.svg",
	"./tab.svg": "./src/icons/svg/tab.svg",
	"./table.svg": "./src/icons/svg/table.svg",
	"./theme.svg": "./src/icons/svg/theme.svg",
	"./themeSetting.svg": "./src/icons/svg/themeSetting.svg",
	"./tijian.svg": "./src/icons/svg/tijian.svg",
	"./tree.svg": "./src/icons/svg/tree.svg",
	"./user.svg": "./src/icons/svg/user.svg",
	"./verification-code.svg": "./src/icons/svg/verification-code.svg",
	"./wechat.svg": "./src/icons/svg/wechat.svg",
	"./welcome.svg": "./src/icons/svg/welcome.svg",
	"./wifi.svg": "./src/icons/svg/wifi.svg",
	"./wmax.svg": "./src/icons/svg/wmax.svg",
	"./wmin.svg": "./src/icons/svg/wmin.svg",
	"./zip.svg": "./src/icons/svg/zip.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/icons/svg sync \\.svg$";